import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import Loader from '../components/common/Loader';
import PublicPricing from '../components/pricing/PublicPricing';
import { useAuth } from '../hooks/useAuth';
import { ANALYTICS_EVENTS, track } from '../services/analytics';

// PUBLIC route (/pricing): the marketing pricing page, shown to a visitor
// who is NOT signed in. Its data source (GET /api/billing/plans) needs no
// auth.
//
// A signed-in user is sent to the in-app plan page instead (/app/billing/
// plans) - that one renders inside AppShell, so the sidebar and topbar
// stay put and there is a real "back to billing" path, rather than
// dumping a paying customer onto a landing-style page with no chrome.
//
// Layout (top to bottom): heading, the five cards, the reassurance line,
// what every plan includes, the FAQ, and "Need help choosing?" - all in
// PublicPricing, shared with the landing page.
function PricingPage() {
  const { user, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && !user) track(ANALYTICS_EVENTS.PRICING_VIEWED, { source: 'pricing_page' });
  }, [isLoading, user]);

  if (isLoading) return <Loader label="Loading plans..." />;
  if (user) return <Navigate to="/app/billing/plans" replace />;

  return (
    <div className="pricing-page">
      <section className="landing-section pricing-section">
        <div className="pricing-bg-grid" aria-hidden="true" />
        <div className="pricing-radial-glow" aria-hidden="true" />

        <div className="pricing-section-inner">
          <PublicPricing />
        </div>
      </section>
    </div>
  );
}

export default PricingPage;
